import { render } from "./GripIcon.vue?vue&type=template&id=624a654f"
import script from "./GripIcon.vue?vue&type=script&lang=js"
export * from "./GripIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__